import { GameEvent, EventWithSequence } from '../../types/game';
import {
  OnlineClientCommand,
  OnlineClientContext,
  OnlineLobbyStateSnapshot,
} from '../../types/transport';
import { OnlineSnapshot } from '../../types/snapshots';
import { AppendEventResult, onlineGameBoundary } from './onlineGameBoundary';

export async function appendEventToOnlineTransport(gameId: string, event: GameEvent): Promise<AppendEventResult> {
  return await onlineGameBoundary.forGame(gameId).appendEvent(event);
}

export async function sendOnlineCommand(
  gameId: string,
  command: OnlineClientCommand,
  client?: Partial<OnlineClientContext>,
  options?: { preferEphemeral?: boolean },
): Promise<boolean> {
  const result = await onlineGameBoundary
    .forGame(gameId, client)
    .sendIntent(command, { delivery: options?.preferEphemeral ? 'ephemeral' : 'auto' });
  return result.success;
}

export async function requestLobbyState(
  gameId: string,
  client?: Partial<OnlineClientContext>,
): Promise<OnlineLobbyStateSnapshot | null> {
  return await onlineGameBoundary.forGame(gameId, client).read.lobby();
}

export async function requestStateSnapshot(
  gameId: string,
  client?: Partial<OnlineClientContext>,
): Promise<OnlineSnapshot | null> {
  return await onlineGameBoundary.forGame(gameId, client).read.snapshot();
}

export async function requestSnapshotEvents(
  gameId: string,
  sinceSequence = 0,
  client?: Partial<OnlineClientContext>,
): Promise<EventWithSequence[]> {
  return await onlineGameBoundary.forGame(gameId, client).read.events(sinceSequence);
}

export async function mirrorEventToOnlineTransport(gameId: string, event: GameEvent): Promise<boolean> {
  const result = await appendEventToOnlineTransport(gameId, event);
  return result.success;
}
